import React from "react";
import {useEffect} from 'react';

const SBS = () => {

    return(
        <React.Fragment>
            <div className="card wisdom-box collapse show mt-3" id="sbs">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className='m-0'>Step by Step</h6>
                </div>
            </div>
        </React.Fragment>
    )
}

export default SBS;